import React, { useEffect, useState } from "react";
import axiosInstance from "../../../services/axiosService";
import { getLabelName } from "./Utils";
import { MultiSelectParamsReadOnly } from "./JobReadOnly";
import MultiselectDropdown from "../MultiselectDropdown";
import { useParams } from "react-router-dom";

const GetMultiSelectParamsData = ({
  keyName,
  params,
  isReadOnly,
  templateObject,
  editJobData,
  preRequirements,
  setParams,
  setEditJobData
  // type
}) => {
  const [options, setOptions] = useState();
  const { orgId } = useParams();
  const multiParamsSelector = (arr, key) => {
    const newParams = { ...params };
    const newArray = arr.map((grp) => grp.id);
    newParams[key] = newArray;

    const index = preRequirements.indexOf(key);
    if (index !== preRequirements.length - 1) {
      for (let i = index + 1; i < preRequirements.length; i++) {
        newParams[preRequirements[i]] = "";
      }
    }
    setParams(newParams);
    setEditJobData(null);
  };

  const getAndSetData = async () => {
    let paramsData = [];
    switch (keyName) {
      case "doc_template_ids":
        const { data: googleGroupData } = await axiosInstance.get(`/googledoc-template`);
        templateObject["send_google_group"] = googleGroupData;
        paramsData = googleGroupData;
        break;

      case "group_ids":
        const { data: groupData } = await axiosInstance.get(`/user-service/groups/org/${orgId}`);
        templateObject["send_group"] = groupData;
        paramsData = groupData;
        break;
      // case "community_group_ids":
      //   const { data: communityGroupData } = await axiosInstance.get(`/community-user-groups`);
      //   templateObject["send_community_group"] = communityGroupData;
      //   paramsData = communityGroupData;
      //   break;
      default:
        break;
    }
    setOptions(paramsData);
  };
  useEffect(() => {
    getAndSetData();
    if (editJobData) {
      setParams({ ...params, [keyName]: editJobData.params[keyName] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);

  if (!options) return;
  return (
    <>
      <MultiSelectParamsData
        keyName={keyName}
        data={options}
        label={getLabelName(keyName)}
        onChange={(newData) => multiParamsSelector(newData, keyName)}
        isReadOnly={isReadOnly}
        params={params}
      />
    </>
  );
};

//individual multi-select dropdown
const MultiSelectParamsData = ({ keyName, data, label, onChange, isReadOnly, params }) => {
  if (isReadOnly) {
    return <MultiSelectParamsReadOnly label={label} data={data} params={params[keyName]} />;
  }
  const getMutiselectedData = (filterIds) => {
    return data.filter((obj) => filterIds.includes(obj.id)).map((obj) => ({ id: obj.id, name: obj.name || obj.title }));
  };

  return (
    <>
      {data && (
        <div className="builder_form">
          <label className="builder_label">Select {label}</label>

          <MultiselectDropdown
            options={data.map((obj) => ({ id: obj.id, name: obj.name || obj.title }))}
            callbackfunction={(data) => onChange(data)}
            selectedData={getMutiselectedData(params[keyName] || [])}
          />
          {/* <MultiSelectBox
              options={data.map((obj) => ({ id: obj.id, name: obj.name || obj.title }))}
              onChange={(data) => onChange(data)}
              selectedData={getMutiselectedData(params[keyName] || [])}
              label={`Select ${label}`}
            /> */}
        </div>
      )}
    </>
  );
};

export default GetMultiSelectParamsData;
